import BoxIcon from './component.jsx'
export default BoxIcon
